export default "__VITE_ASSET__D894Mcc8__"